import type { DirectoryUser } from '../api/usersService'

const haystack = (user: DirectoryUser): string =>
  [
    user.display_name,
    user.user_principal_name,
    user.mail,
    user.job_title,
    user.department,
    user.company_name,
  ]
    .filter(Boolean)
    .join(' ')
    .toLowerCase()

// Every word typed must appear somewhere (name, UPN, mailbox, job title,
// department or company); names that start with the first word come first.
export const searchDirectory = (
  users: DirectoryUser[],
  query: string
): DirectoryUser[] => {
  const words = query.trim().toLowerCase().split(/\s+/).filter(Boolean)
  if (words.length === 0) return users
  const matches = users.filter(u => {
    const text = haystack(u)
    return words.every(w => text.includes(w))
  })
  const first = words[0]
  const starts = (u: DirectoryUser) =>
    u.display_name.toLowerCase().startsWith(first) ||
    u.user_principal_name.toLowerCase().startsWith(first)
  return [...matches.filter(starts), ...matches.filter(u => !starts(u))]
}

// The detail line under a person's name: UPN, then job title and team.
export const secondaryLine = (user: DirectoryUser): string => {
  const where = [user.job_title, user.department ?? user.company_name]
    .filter(Boolean)
    .join(' · ')
  return where
    ? `${user.user_principal_name} · ${where}`
    : user.user_principal_name
}
